import { v4 as uuid } from 'uuid'

export const areas = [
    {
        ID:uuid(),
        area:"Front-End"
    },
    {
        ID:uuid(),
        area:"Back-End"
    },
    {
        ID:uuid(),
        area:"Mobile"
    },
    {
        ID:uuid(),
        area:"Adicional"
    },
]